import React, { Component } from 'react';
//import PropTypes from "prop-types";
import {Form, Control, Errors} from 'react-redux-form';
import {allLower, allUpper/*, firstCapital*/} from "../parsers";
import {isCurp, isEmail, email, required, isRequired, isRfc, maxLength, phoneNumber, minValue} from "../field_validations";
import DatePick from "../forms/datepicker";
import _ from 'lodash';
import Loading from './../../elements/loading';
import GreetingsSelect from "../forms/greeting_select";

export default class EmployeesEditForm extends Component{
    render(){
        const {cdms, session, match} = this.props;
        let agency = _.find(session.user.cdms, {agenciable_slug: match.params.municipality});
        let employeesAgency = _.filter(cdms.data.employees,{agency_id: agency.agency_id, status_id: 1});
        let ec = _.find(cdms.permissions, (o) => {return o==='Create'});
        return(
            <div className="columns is-centered">
                    <div className="column">
                        <Form model="cdms.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
    						<div className="field is-grouped">
    							<div className="control">
    								<label htmlFor="role_id" className="label">Perfiles <span className="small has-text-danger">*</span></label>
    								<div className={`select${cdms.isFetching ? ' is-loading' : ''}`}>
                                        <Control.select model=".role_id" ref="roleSelect" id="role_id" value={cdms.edit && cdms.edit.role_id ? cdms.edit.role_id:""} changeAction={(m,v) => this._handleChangeRole(m,v)} errors={{required}} validateOn="change">
                                            <option value="" defaultValue>-- Perfiles --</option>
    										{_.map(cdms.data.roles, (option, key) => {
    											let registred = _.find(cdms.data.employees,{role_id: option.id, agency_id: agency.agency_id, status_id: 1});
    											return <option key={key} value={option.id} className={registred === undefined ? 'has-text-danger':''}>{`${option.display}`}</option>;
    										})}
                                        </Control.select>
    								</div>
    								<Errors model=".role_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debe seleccionar un perfil' }} />
    							</div>

    							<div className="control">
    								<p style={{marginBottom:'.5em'}}>&nbsp;</p>
    								<div className="tags has-addons">
    									<span className="tag is-medium is-dark">Perfiles cargados</span>
    									<span className="tag is-medium is-inm-purple">{_.size(employeesAgency)}</span>
    								</div>
    							</div>

    							<div className="control">
    								<p style={{marginBottom:'.5em'}}>&nbsp;</p>
    								<div className="tags has-addons">
    									<span className="tag is-medium is-dark">Perfiles pendientes</span>
    									<span className="tag is-medium is-danger">{_.size(cdms.data.roles) - _.size(employeesAgency)}</span>
    								</div>
    							</div>
    						</div>

    						{cdms.edit.isFetching ? <Loading message="Cargando perfil..." />:
    							[<h5 className="is-5 title" key="cdms-title" style={{marginTop: '30px'}}>Datos generales</h5>,
    								<div className="hero is-light" key="cdms-info">
    									<div className="hero-body">
    										<div className="field is-grouped">
    											<div className="control">
    												<label htmlFor="title" className="label">Saludo <span className="small has-text-danger">*</span></label>
    												<div className={`select${cdms.isFetching ? ' is-loading' : ''}`}>
    													<Control model=".title" id="title" component={GreetingsSelect} value={cdms.edit && cdms.edit.title ? cdms.edit.title:''} validateOn="change" errors={{isRequired}} />
    												</div>
    												<Errors model=".title" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Debes elegir un saludo'}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
    												<Control.text model=".name" className={`input`} id="name" errors={{isRequired}} validateOn="change" />
    												<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="last_name" className="label">Primer apellido <span className="small has-text-danger">*</span></label>
    												<Control.text model=".last_name" className={`input`} id="last_name" errors={{isRequired}} validateOn="change"/>
    												<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="slast_name" className="label">Segundo apellido</label>
    												<Control.text model=".slast_name" className={`input`} id="slast_name"/>
    											</div>
    										</div>

    										<div className="field is-grouped">
    											<div className="control is-expanded">
    												<label htmlFor="scholarship" className="label">Escolaridad <span className="small has-text-danger">*</span></label>
    												<Control.text model=".scholarship" id="scholarship" className={`input`} placeholder="Escolaridad" errors={{isRequired}}/>
    												<Errors model=".scholarship" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El Nombramiento es obligatoria'}} />
    											</div>
    										</div>

                                            <div className="field is-grouped">
            									<div className="control">
            										<label htmlFor="wage" className="label">Ingreso mensual</label>
            										<div className="control has-icons-left is-expanded">
            											<Control.text model=".wage" id="wage" type="number" step=".01" min="0" className="input" placeholder="0,000.00" errors={{isRequired, minValue: minValue(0)}} validateOn="change" />
            											<span className="icon is-small is-left">
            												<i className="fa fa-usd"/>
            											</span>
            										</div>
            										<Errors model=".wage" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
            									</div>
            								</div>

    										<div className="field is-grouped">
    											<div className="control is-expanded">
    												<label htmlFor="period_start" className="label">Fecha en que asumió cargo <span className="small has-text-danger">*</span></label>
    												<Control.text model=".period_start" id="period_start" className={`input`} errors={{isRequired}} component={DatePick}/>
    												<Errors model=".period_start" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha en la que asumió el cargo es obligatoria. '}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="period_end" className="label">Fin de gestion <span className="small has-text-danger">*</span></label>
    												<Control.text model=".period_end" id="period_end" className={`input`} component={DatePick} errors={{isRequired}} validateOn="change"/>
                                                    <Errors model=".period_end" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La fecha fin de gestion es obligatoria. '}} />
    											</div>
    										</div>

    										<div className="field is-grouped">
    											<div className="control">
    												<label htmlFor="sex" className="label">Sexo <span className="small has-text-danger">*</span></label>
    												<div className={`select${cdms.isFetching ? ' is-loading' : ''}`}>
    													<Control.select model=".sex" id="sex" value={cdms.edit && cdms.edit.sex ? cdms.edit.sex:''} errors={{isRequired}} validateOn="change">
    														<option value="">--- Sexo ---</option>
    														<option value="M">Mujer</option>
    														<option value="H">Hombre</option>
    													</Control.select>
    												</div>
    												<Errors model=".sex" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El sexo es obligatorio'}} />
    											</div>
    											<div className="control is-expanded">
    												<label htmlFor="rfc" className="label">RFC <span className="small has-text-danger">*</span></label>
    												<Control.text model=".rfc" id="rfc" className={`input`} placeholder="RFC" errors={{isRequired, isRfc}} validateOn="change" parser={ allUpper }/>
    												<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El RFC es obligatorio. ', isRfc: 'RFC inválido. '}} />
    											</div>
    											<div className="control is-expanded">
    												<label htmlFor="curp" className="label">CURP <span className="small has-text-danger">*</span></label>
    												<Control.text model=".curp" id="curp" className={`input`} placeholder="CURP" errors={{isRequired, maxLength: maxLength(18), isCurp}} validateOn="change" parser={ allUpper }/>
    												<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La CURP es obligatoria. ', maxLength: 'CURP inválida. '}} />
    											</div>
    										</div>

                                            <div className="field is-grouped">
                                                <div className="control is-expanded">
                                                    <label htmlFor="rfc_invoices" className="label">RFC facturas expedidas </label>
                                                    <Control.text model=".rfc_invoices" id="rfc_invoices" className="input" placeholder="XXXX000000XX0" errors={{ isRfc}} validateOn="change" parser={ allUpper }/>
                                                    <Errors model=".rfc_invoices" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRfc: 'RFC inválido. '}} />
                                                </div>

                                                <div className="control">
                                                    <div className="notification is-warning">
                    									<i className="fa fa-info"/>&nbsp; Si las facturas son expedidas con otro RFC que no es el de la persona contratada, agregalo aquí.
                    								</div>
                                                </div>
                                            </div>

    										<div className="field is-grouped">
    											<div className="control is-expanded">
    												<label htmlFor="email" className="label">Email principal<span className="small has-text-danger">*</span></label>
    												<Control.text model=".email" className={`input`} placeholder="Email principal *" errors={{isRequired, isEmail}} validateOn="change" parser={ allLower }/>
    												<Errors model=".email" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El email es obligatorio'}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="email_2" className="label">Email secundario </label>
    												<Control.text model=".email_2" id="email_2" className={`input`} placeholder="Email secundario" errors={{email}} validateOn="change" parser={ allLower }/>
    												<Errors model=".email_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{email}} />
    											</div>
    										</div>

    										<div className="field is-grouped">
    											<div className="control is-expanded">
    												<label htmlFor="telephone" className="label">Teléfono principal <span className="small has-text-danger">*</span></label>
    												<Control.text model=".telephone" value={cdms.edit && cdms.edit.telephone ? cdms.edit.telephone:''} id="telephone" className={`input`} placeholder="Teléfono principal" maxLength={10} errors={{isRequired, phoneNumber}} validateOn="change"/>
    												<Errors model=".telephone" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El Teléfono es obligatorio'}} />
    											</div>

    											<div className="control is-expanded">
    												<label htmlFor="telephone_2" className="label">Teléfono alterno</label>
    												<Control.text model=".telephone_2" id="telephone_2" className={`input`} maxLength={10} placeholder="Teléfono alterno" errors={{phoneNumber}} validateOn="change"/>
    												<Errors model=".telephone_2" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{phoneNumber}} />
    											</div>
    										</div>
    									</div>
    								</div>]}

    						<div className="field is-grouped is-grouped-right" style={{marginTop: '30px'}}>
    							<div className="control">
    								<button type="button" model="project" className="button is-large" onClick={() => this.props.history.goBack()}>Regresar</button>
    							</div>

                                {ec ?
                                <div className="control">
    								<Control.button model="cdms.edit" className="button is-large is-primary" disabled={false}>Guardar</Control.button>
    							</div>:''}
    						</div>

    						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
    					</Form>
                    </div>
            </div>
        )
    }

    _handleSubmit(values){
        let {match} = this.props;
		this.props.cdmEmployeesSave(match.params.state, values);
	}

    _handleChangeRole(model,value) {
		//let selector = this.refs['roleSelect'];
		if(value){
			//this._loadEmployee(selector.value,selector[selector.selectedIndex].dataset.type,selector[selector.selectedIndex].dataset.agency);
			this._loadEmployee(value);
		}
	}

	_loadEmployee(roleId){
		const { cdms, match, session } = this.props;
		let employee = {};
        let agency = _.find(session.user.cdms, {agenciable_slug: match.params.municipality});

		employee = _.find(cdms.data.employees, {role_id: _.toNumber(roleId), agency_id:_.toNumber(agency.agency_id), status_id: 1})

		let response = {role_id: _.toNumber(roleId), agency_id: _.toNumber(agency ? agency.agency_id:undefined)}
		if(employee){
			_.mapKeys(employee,(item, key) => {
				response = {
					...response,
					[key]:item ? item:undefined
				}
			})
		}else {
			response = {
				...response,
				title: undefined, name: undefined, last_name: undefined, slast_name: undefined, sex: undefined, curp: undefined, rfc: undefined, scholarship: undefined, rfc_invoices: undefined,
				email: undefined, email_2: undefined, telephone: undefined, telephone_2: undefined, period_start: undefined, period_end: undefined
			}
		}

		this.props.loadFormData('cdms.edit', {...response});
	}
}



// WEBPACK FOOTER //
// ./src/elements/cdms/employees.jsx